

import {apiPost, apiRequest} from '../utils/request';
import {toastr} from 'react-redux-toastr';

export function updateTank({payLoad}) {
    return function (dispatch) {
      toastr.success('Saving tanks');
      return apiPost(`/api/tanks/updateAssetRollout`, payLoad)
        .then(x => {
          if (x && (x.error || x.data.Message)) {
            let message = `Error saving tanks, error: ${x.error ? x.error : x.data.Message}`;
            toastr.error(message);
          }
          return x; 
        });
    };
  }

  export function validateTank({assetRollout, tankId, runId, pickupId, latitude, longitude}) {
    return function (dispatch) {
      toastr.success('Validating tank');
      return apiRequest(`/api/tanks?id=${tankId}&runId=${runId}&pickupId=${pickupId}&latitude=${latitude}&longitude=${longitude}${assetRollout ?"&checkAssetRollout=true" : ""}`)
        .then(x => {
          return x;
        });
    };
  }